import { Language } from 'ha/i18n';
import { MakeCall } from 'ha/services/apiV2/createMakeCall';

import { APIV2_URL } from './constants';
import { City } from './types/City';

interface FeaturedCitiesResource {
  cities: City[];
  count: number;
}

export interface Query {
  lang?: Language;
  include?: string;
  exclude?: string;
}

export default (makeCall: MakeCall) => (query?: Query) =>
  makeCall<FeaturedCitiesResource>(
    'GET',
    `${APIV2_URL}/geonames/cities/featured`,
    {
      query,
    },
  );
